import React, { Component } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField/index';
import {insertSubmitMonth} from '../../../../../../services/InsertSubmit'
import Typography from '@material-ui/core/Typography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
moment.locale('es')
                                                                                                             
class WindowModal extends Component {

    
    constructor(props) {
        super(props);
        //console.log(props.row)
        var requiredOut=false
        var requiredError=false
        if(props.row.fuera===0){
            requiredOut=true
        }
        if(props.row.error===0){
            requiredError=true
        }
        sessionStorage.setItem("dataM", JSON.stringify(this.props.row))
        sessionStorage.setItem("prevDataM", JSON.stringify(this.props.row))

        this.state = {
            dataObjective:this.props.dataObjective,
            month:this.props.row.mes,
            perf:this.props.row.perf,
            error:this.props.row.error,
            out:this.props.row.fuera,
            data:this.props.row,
            errorValue:false,
            average:this.props.row.tiempo,
            msg:["Valores Ingresados deben tener como Resultado 100%"], 
            indexmsg:0,
            fieldChange:'',
            OutRequired:requiredOut,
            ErrorRequired:requiredError,
            openPop:false,
            anchorPop:null,
            restore: true
        }
    }

    validateName = (type, value) => {
        //console.log('valid', isNaN(parseFloat(value)))
        if(isNaN(parseFloat(value))){
            if(type==="perf"){
                this.setState({
                    validPerf:true
                });
            }else if(type==='fuera'){
                this.setState({
                    validOut:true
                });
            }else if(type==='error'){
                this.setState({
                    validError:true
                });
            }
            else if(type==='average'){
                this.setState({
                    validAverage:true
                });
            }
        }
    }

    handleFieldChange = (field, value) => {
        /* const {error, fieldChange, out, perf}=this.state
        console.log(perf,out, error, fieldChange); */
        if (field === "error") {
            this.setState({
                OutRequired: true,
                ErrorRequired: false,
                errorValue: false,
                isRefreshError: true,
                isRefreshOut: false,
                error: value,
                fieldChange: field
            });

        } else if (field === "fuera") {
            this.setState({
                OutRequired: false,
                ErrorRequired: true,
                errorValue: false,
                isRefreshError: false,
                isRefreshOut: true,
                out: value,
                fieldChange: field
            });

        } 
        else if (field === "average") {
            this.setState({
                average: value,
                fieldChange: field,
                restore: false
            });
        }

    }

    save=()=>{
        const {month, data, error, out, perf, dataObjective, average}=this.state
        //console.log('save', perf, error, out)
        var total = parseFloat((parseFloat(perf) + parseFloat(out) + parseFloat(error)).toFixed(0))
        //console.log(total)
        if(total!==100){
            this.setState({
                errorValue:true
            });
        }else{
            insertSubmitMonth(month, dataObjective.objetivo_id, dataObjective.paso, dataObjective.sla_performance, perf, error, out,average).then( data => {
                this.props.handleCloseControl()
                this.setState({
                    errorValue:false
                });
            })
            this.props.handleControl(month)
            this.close()
        }
        sessionStorage.clear();
    }


    close=()=>{
        sessionStorage.clear();
        this.props.handleCloseControl()
    }



    change=(e)=>{
        const {month, error, fieldChange, out, perf, average}=this.state
        /* console.log(perf, out, error, average); */
        let errorNum = parseFloat(error.toString().replace(",", "."))
        let outNum = parseFloat(out.toString().replace(",", "."))
        var dataSessionM = JSON.parse(sessionStorage.getItem("dataM"))
        var prevDataSessionM = JSON.parse(sessionStorage.getItem("prevDataM"))
        var newError = errorNum
        var newOut = outNum
        var newPerf = parseFloat(dataSessionM.perf)
        // console.log(newPerf, perf);
        if (perf === newPerf) {
            newPerf = parseFloat(dataSessionM.perf)
            if (fieldChange === "error") {
                newPerf = (parseFloat(dataSessionM.error) - errorNum) + newPerf
            }
            if (fieldChange === "fuera") {
                newPerf = (parseFloat(dataSessionM.fuera) - outNum) + newPerf
            }
        }
        else {
            newPerf = parseFloat(prevDataSessionM.perf)
            if (fieldChange === "error") {
                newPerf = (parseFloat(prevDataSessionM.error) - errorNum) + newPerf
            }
            if (fieldChange === "fuera") {
                newPerf = (parseFloat(prevDataSessionM.fuera) - outNum) + newPerf
            }
        }

        var prevDataM = {
            month: month,
            perf: newPerf,
            fuera: newOut,
            error: newError,
            tiempo: average,
            
        }

        newPerf=parseFloat(newPerf.toFixed(1))
        
        if(newPerf<100){
            sessionStorage.setItem("prevDataM", JSON.stringify(prevDataM))
            this.setState({
                perf: newPerf,
                out: newOut,
                error: newError,
                OutRequired: false,
                ErrorRequired: false,
                isRefreshError: false,
                isRefreshOut: false,
                restore: false,
                validPerf: false,
                validOut: false,
                validError: false,
                validAverage: false
            });
            
        }else if(newPerf===100){
            this.setState({
                perf:100,
                OutRequired:true,
                ErrorRequired:true,
                isRefreshError:false,
                isRefreshOut:false,
            });
        }else{
            this.setState({
                perf:100,
                isRefreshError:false,
                errorValue:true,
                isRefreshOut:false,
            });
        }
        
    }


    restoreBtn = (e) => {
        var dataSessionM = JSON.parse(sessionStorage.getItem("dataM"))
        this.setState({
            perf: parseFloat(dataSessionM.perf),
            out: parseFloat(dataSessionM.fuera),
            error: parseFloat(dataSessionM.error),
            average: parseFloat(dataSessionM.tiempo),
            OutRequired: false,
            ErrorRequired: false,
            restore: false
        });

    }




    handlePopover=(event)=>{
        this.setState(prevState => ({
            openPop: !prevState.openPop,
            anchorPop:event.currentTarget
        }));
    }
    

    render() {
        const {classes}= this.props
        const {validPerf, validOut, validError, validAverage, perf,out, error, month, errorValue, average, msg, indexmsg, 
            isRefreshOut,isRefreshError, OutRequired, ErrorRequired, openPop , anchorPop , restore}=this.state
        //console.log('render window', 'fuera disable', OutRequired, 'error disable',  ErrorRequired)
        //console.log(openPop)
        return(
        <Grid
            container
            spacing={1}
            style={{backgroundColor:"white", width:"35%"}}
        >
            <Grid
                item
                xs={10}
                sm={10}
                md={10}
                xl={10}
                style={{textAlign:"right"}}
            >
                <Button onClick={this.handlePopover}><InfoIcon style={{color:"#ff7800"}}/></Button>
                <Popover 
                    open={openPop}
                    anchor={anchorPop}
                    onClose={this.handlePopover}
                    style={{width:"60%", inset:"-150px 150px 0px"}}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                >
                    <Grid
                        container
                        spacing={1}
                        style={{backgroundColor:"#ff7800"}}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                            style={{textAlign:"left", color:"white", padding:"25px"}}
                        >
                            <Typography variant="h5" style={{padding:"4px"}}>INFORMACIÓN</Typography>
                            <Typography variant="h6" style={{fontSize:"1rem"}}> Tabla que permite el cambio de Performance, a través de la 
                                modificacion de los parametros de error y fuera de sla. </Typography>
                            <Typography variant="h6" style={{fontSize:"1rem"}}>Cuando se obtiene el total de 100% la tabla queda deshabilitada</Typography>

                        </Grid>
                    </Grid>
                </Popover>
            </Grid>
            <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
                style={{textAlign:"right"}}
            >
                <Button onClick={this.close}><CloseIcon/></Button>
            </Grid>

            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <TextField
                    id="standard-read-only-input"
                    label="Mes"
                    disabled
                    defaultValue={month}
                />
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center", paddingBottom:"5px"}}
            >
                <TextField
                    label="Tiempo de respuesta Promedio"
                    varian="filled"
                    value={average}
                    onChange={event =>
                        this.handleFieldChange('average', event.target.value)
                    }
                    onBlur={event =>
                        this.validateName('average',event.target.value)
                    }
                    error={validAverage}
                    helperText={validAverage? 'Por favor ingrese un numero válido' : ' '}
                    variant="outlined"
                    inputProps={{maxLength :40}}
                />
            </Grid>
            <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{ textAlign: "center" }}
                >
                    <Button onClick={this.restoreBtn} className={classes.button} disabled={restore}>Restaurar</Button>
                </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <TextField
                    label="Performance"
                    varian="filled"
                    value={perf}
                    onChange={event =>
                        this.handleFieldChange('perf', event.target.value)
                    }
                    disabled
                    onBlur={event =>
                        this.validateName('perf',event.target.value)
                    }
                    error={validPerf}
                    helperText={validPerf ? 'Por favor ingrese un numero válido' : ' '}
                    variant="outlined"
                    inputProps={{maxLength :40}}
                />
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <TextField
                    style={{paddingRight:"10px"}}
                    label="Fuera de Sla"
                    varian="filled"
                    value={out}
                    onChange={event =>
                        this.handleFieldChange('fuera', event.target.value)
                    }
                    disabled={OutRequired}
                    onBlur={event =>
                        this.validateName('fuera', event.target.value)
                    }
                    error={validOut}
                    helperText={validOut ? 'Por favor ingrese un numero válido' : ' '}
                    variant="outlined"
                    inputProps={{maxLength :40}}
                />
                {isRefreshOut?
                <Button value="fuera" className={classes.button} onClick={this.change}>Actualizar<ArrowForwardIosIcon/></Button>
                :   null}
            </Grid>
            
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <TextField
                    label="Error"
                    varian="filled"
                    value={error}
                    style={{paddingRight:"10px"}}
                    onChange={event =>
                        this.handleFieldChange('error', event.target.value)
                    }
                    disabled={ErrorRequired}
                    onBlur={event =>
                        this.validateName('error',event.target.value)
                    }
                    error={validError}
                    helperText={validError ? 'Por favor ingrese un numero válido' : ' '}
                    variant="outlined"
                    inputProps={{maxLength :40}}
                />
                {isRefreshError?
                <Button value="error" className={classes.button} onClick={this.change}>Actualizar<ArrowForwardIosIcon/></Button>
                :   null}
                
            </Grid>
            
            
            {errorValue?
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Typography style={{backgroundColor:"red", color:"white"}}>{msg[indexmsg]}</Typography>
            </Grid>:null
            }
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Button onClick={this.save} className={classes.button}>Guardar</Button>
            </Grid>
        </Grid>
    )
        
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(WindowModal);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlMonthObjective/WindowModal/index.jsx